import {handleError} from '../../common/utils/errorHandling';
import httpClient from '../../common/services/httpClient';

interface PublicationListingDto {
  readonly id: string;
  readonly name: string;
  readonly title: string;
}

class PublicationsService {
  public async getAllPublications(): Promise<PublicationListingDto[]> {
    return handleError(
      () => httpClient.get<PublicationListingDto[]>('/publications'),
      'Error fetching publications:',
      () => []
    );
  }
}

const publicationsService = new PublicationsService();
export default publicationsService;

